import { render } from "./CompoundMix.vue?vue&type=template&id=1cb4bc1e&ts=true"
import script from "./CompoundMix.vue?vue&type=script&lang=ts"
export * from "./CompoundMix.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__